import type { TableRow } from "@/components/ui/standardized-table";

/**
 * O rodapé "Total Geral" de uma tabela paginada pelo servidor — ou `null`, quando não há
 * conjunto para descrever.
 *
 * As rotas da Taxa de Conversão publicam esse rodapé de duas maneiras diferentes, e é essa
 * divergência que esta função nivela. Em M-226, M-227 e M-228 o campo é **nulo quando o
 * conjunto está vazio**, porque foi acrescentado por este porte e o invariante pôde ser
 * escolhido. Nas rotas herdadas do contrato congelado —
 * `GET /api/v1/conversion-rate/utm-campaigns` (M-229) e as quatro que servem as tabelas de
 * estado, cidade, dispositivo e grupo de canais (M-230) — `total_row` é obrigatório e sai
 * **zerado** quando não há linha nenhuma. Divergir do contrato herdado só para ganhar
 * coerência de schema não compensa; o invariante passa a valer na **tela**, onde ele importa,
 * para que uma tabela vazia continue sem rodapé como as demais.
 *
 * O gatilho é o **conjunto** e não a página: uma página fora de faixa sai com `items: []`
 * sobre um conjunto cheio, e aí o rodapé descreve o universo que existe — a escolha de M-228.
 * Quem pagina passa `pagination.total`; `devices-sales`, que não pagina, passa a quantidade
 * de linhas que veio.
 */
export const rodapeDoConjunto = (
  totalRow: unknown,
  totalDoConjunto: number | undefined,
): TableRow | null =>
  Number(totalDoConjunto ?? 0) > 0 ? (totalRow as TableRow) : null;
